import { dantribes } from "./data";
import "./footer.css";

const Footer = () => {
  return (
    <div id="footer" data-aos="fade-in">
      <div className="container">
        <div data-aos="fade-down" className="footer__container">
          <div>
            <h4>Email</h4>
            info.renovation@cartiltd.ca
          </div>
          <div>
            <h4>Telephone</h4>
            +1 343-987-8450
          </div>
          <div>
            <h4>Head Office</h4>
            Gatineau Quebec, Canada
          </div>
        </div>

        <div className="line_between"></div>
        <div className="term_copy_right_div ">
          <div id="terme__condition">
            <small>Terms & Policy</small>
            <div className="terme_condition-show ">
              <h4>General Policies</h4>
              <p>
                These general Polices govern the use of Carti Ltd web site
                <br />
                
              </p>

              <h4>Propriété intelectuelle</h4>
              <p>
              This website is owned by Cartiltd and administered by DanTribes. 
By using this site, you indicate that you have read and understood the terms of use and that you agree to comply with them at all times.
              </p>

              <h4>Age restriction</h4>
              <p>
              The minimum age to use this site is 0 years. Users agree that using our website they are over 0 years old
              <br />
              We assume no legal responsibility for misrepresentations of age.
              </p>
              <h4>Limitation of liability</h4>
              <p>
              Cartiltd or DanTribes administrator will be required
responsible for any technical problems arising from this site
                web.
                <br />
                However, Cartiltd or the administrator Dans Tribes will not be held responsible for any problems arising from the irregular use of this website.
              </p>
              <h4>Compensation</h4>
              <p>
              As a user, you hereby indemnify and hold harmless from any liability, costs, causes of action, damages or expenses arising out of your use of this site or your breach of any of the provisions set out in this document
              </p>

              <h4>Applicable laws</h4>
              <p>
              This document is subject to the applicable laws of Canada and is intended to comply with its necessary rules and regulations
              </p>
              <p>
              For EU residents, the GDPR is the applicable law governing this document. In the event of any incompatibility between a provision of this document and the GDPR, the rules of the GDPR will take precedence
              </p>
              <h4>Divisibility</h4>
              <p>
              If at any time any of the provisions set forth herein are found to be inconsistent or invalid under applicable law, such provisions shall be deemed void and shall be removed from this document.
              Any other provisions will not be affected by the laws and the rest of the document will still be considered valid
              </p>

              <h4>Changes</h4>
              <p>
              These terms and conditions may be amended from time to time in order to maintain compliance with the law and to reflect any changes to the way our website operates and the way we expect users to behave on our site
                <br />
                We recommend that our users check these terms and conditions from time to time to ensure that they are aware of any updates.
                If necessary, we will notify them by email of changes to these conditions or we will post a notice on our website.
              </p>
              <div className="datecon">
                <span>DEffective date:</span> le 01 Novembre 2024
              </div>
            </div>
          </div>
          {/* <div className="footer__socials">
          {socials.map((soc) => (
            <a
              key={soc.id}
              href={soc.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {soc.icon}
            </a>
          ))}
        </div> */}
          <div className="footer__copyright">
            <small>2024 Carti Ltd</small>
            <p>
              <small>
                <span className="dantribes">
                  {dantribes.map((dan) => (
                    <a
                      className="dantribes"
                      key={dan.id}
                      href={dan.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="Dan">Dan</span>Tribes
                    </a>
                  ))}{" "}
                </span>{" "}
                &copy; All Rights Reserved
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
